<template>
  <div class="relative flex flex-col gap-2">
    <TransitionGroup name="banner-slide">
      <div v-for="toast in toasts" :key="toast.id" class="notification notification_toast">
        <div>
          {{ toast.message }}
        </div>
      </div>
    </TransitionGroup>
  </div>
</template>

<script setup>
import { useUiStore } from "@/stores/ui";
import { computed } from "vue";

const uiStore = useUiStore();

const toasts = computed(() => uiStore.toasts);
</script>
